import type { ReactNode } from "react";

type OptionGlyphProps = {
  optionId: string;
};

const Stroke = ({
  children,
}: {
  children: ReactNode;
}) => (
  <g
    fill="none"
    stroke="currentColor"
    strokeWidth="1.55"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </g>
);

const renderGlyph = (optionId: string) => {
  switch (optionId) {
    case "just_me":
      return (
        <Stroke>
          <circle cx="12" cy="10" r="3.1" />
          <path d="M12 13.3v4.7" />
          <path d="M8.7 16.4c.8 1.1 1.9 1.6 3.3 1.6s2.5-.5 3.3-1.6" />
        </Stroke>
      );
    case "partner":
      return (
        <Stroke>
          <circle cx="9.2" cy="11" r="2.8" />
          <circle cx="14.8" cy="11" r="2.8" />
          <path d="M6.9 17c.8-1.7 2.2-2.6 4.1-2.6" />
          <path d="M13 14.4c1.9 0 3.3.9 4.1 2.6" />
        </Stroke>
      );
    case "family":
      return (
        <Stroke>
          <path d="M7.4 10.6 12 6.9l4.6 3.7v6.9H7.4z" />
          <path d="M10.5 17.5v-3h3v3" />
        </Stroke>
      );
    case "kids":
    case "share_with_kids":
    case "teach_kids":
      return (
        <Stroke>
          <circle cx="12" cy="9" r="2.2" />
          <path d="M12 11.4v5" />
          <path d="M9 13.4c.7.9 1.7 1.4 3 1.4s2.3-.5 3-1.4" />
          <path d="M9.5 17.8h5" />
        </Stroke>
      );
    case "just_starting":
    case "friends_entertaining":
      return (
        <Stroke>
          <path d="M7.1 7.1h4.8a2.1 2.1 0 0 1 1.5.6l.9.9h2.6v8.6h-4.2a2 2 0 0 0-1.5-.6H7.1V7.1z" />
          <path d="M12 7.8v8.8" />
        </Stroke>
      );
    case "yes":
    case "yes_absolutely":
    case "waste_stress":
      return (
        <Stroke>
          <circle cx="12" cy="12" r="6.4" />
          <path d="M9.3 12.2l1.8 1.9 3.8-4.2" />
        </Stroke>
      );
    case "no":
    case "not_really":
      return (
        <Stroke>
          <circle cx="12" cy="12" r="6.4" />
          <path d="M9.5 9.5l5 5" />
          <path d="M14.5 9.5l-5 5" />
        </Stroke>
      );
    case "beginner":
    case "simple":
      return (
        <Stroke>
          <path d="M12 18.1v-4.7" />
          <path d="M12 13.4c0-3.2 1.5-5.4 4.1-6.8 0 2.9-1.2 5.2-4.1 6.8Z" />
          <path d="M12 13.4c0-2.4-1.2-4.2-3.5-5.5 0 2.3 1 4.2 3.5 5.5Z" />
        </Stroke>
      );
    case "inconsistent_practice":
    case "follow_recipe":
    case "full_picture":
      return (
        <Stroke>
          <path d="M8 6.2h6.8a1.8 1.8 0 0 1 1.8 1.8v9.8H9.8A1.8 1.8 0 0 0 8 19.6z" />
          <path d="M8 6.2v13.4" />
          <path d="M10.6 10.1h4.2" />
          <path d="M10.6 13.1h4.2" />
        </Stroke>
      );
    case "comfortable":
    case "calmer_mind":
    case "eat_healthier":
      return (
        <Stroke>
          <circle cx="12" cy="12" r="5.8" />
          <path d="M12 8.2v4.1l2.8-2.1" />
          <path d="M12 5.1v1.3" />
        </Stroke>
      );
    case "masterchef":
    case "real_depth":
      return (
        <Stroke>
          <path d="M6.9 16.5h10.2" />
          <path d="M8 16.5c.5-4.9 2-8 4-9.5 2 1.5 3.5 4.6 4 9.5" />
          <path d="M9.2 18.6h5.6" />
        </Stroke>
      );
    case "daily_consistency":
    case "healthier":
      return (
        <Stroke>
          <circle cx="8.2" cy="14.4" r="1.2" />
          <circle cx="12" cy="11.8" r="1.2" />
          <circle cx="15.8" cy="9.2" r="1.2" />
          <path d="M7 16c1.4-1.6 3.1-3.1 9.8-7.7" />
        </Stroke>
      );
    case "calm_mind_speech":
    case "save_money":
      return (
        <Stroke>
          <path d="M7.3 8.4h9.4a2 2 0 0 1 2 2v4.6a2 2 0 0 1-2 2H12l-3.4 2.4v-2.4H7.3a2 2 0 0 1-2-2v-4.6a2 2 0 0 1 2-2Z" />
          <path d="M8.8 11.6h6.4" />
          <path d="M8.8 14.2h4.6" />
        </Stroke>
      );
    case "deeper_saakhis":
    case "new_cuisines":
      return (
        <Stroke>
          <path d="M7.4 8.1h4.5a2 2 0 0 1 1.5.6l.8.8h2.4v7.8h-4.1a2 2 0 0 0-1.5-.6H7.4V8.1z" />
          <path d="M12 8.8v7.9" />
          <path d="M16.9 6.3l.5 1.4 1.5.5-1.5.5-.5 1.5-.5-1.5-1.5-.5 1.5-.5.5-1.4Z" />
        </Stroke>
      );
    case "feed_family":
    case "family_presence":
    case "family_enjoys":
      return (
        <Stroke>
          <circle cx="9" cy="10.1" r="1.8" />
          <circle cx="15" cy="10.1" r="1.8" />
          <circle cx="12" cy="8.4" r="1.7" />
          <path d="M6.8 16.1c.8-1.7 2.1-2.7 4.1-2.7" />
          <path d="M13.1 13.4c2 0 3.3 1 4.1 2.7" />
          <path d="M9.6 15.8c.6-1.3 1.4-2 2.4-2s1.8.7 2.4 2" />
        </Stroke>
      );
    case "technique":
      return (
        <Stroke>
          <path d="M7.2 13.7c1.1-1.5 2.7-2.3 4.8-2.3s3.7.8 4.8 2.3" />
          <path d="M8.5 10.3c.9-1 2.1-1.5 3.5-1.5s2.6.5 3.5 1.5" />
          <path d="M10.1 17c.5-.7 1.1-1 1.9-1s1.4.3 1.9 1" />
        </Stroke>
      );
    case "something_french":
      return (
        <Stroke>
          <path d="M5.8 12c1.7-2.6 3.8-3.9 6.2-3.9s4.5 1.3 6.2 3.9c-1.7 2.6-3.8 3.9-6.2 3.9S7.5 14.6 5.8 12Z" />
          <circle cx="12" cy="12" r="1.8" />
        </Stroke>
      );
    case "five_min_routine":
    case "less_time":
    case "short_anchor":
    case "quick_15":
      return (
        <Stroke>
          <path d="M13.2 4.8L8.5 12h3.5l-1.2 7.2 4.7-7.2h-3.5z" />
        </Stroke>
      );
    case "less_waste":
    case "first_impression":
      return (
        <Stroke>
          <path d="M12 5.9 16.2 10 12 14.1 7.8 10 12 5.9Z" />
          <path d="M12 14.1v4" />
          <path d="M9.2 18.1h5.6" />
        </Stroke>
      );
    case "too_tired":
    case "less_stress":
      return (
        <Stroke>
          <path d="M6.2 13.6c1.5-1.8 3.4-2.6 5.8-2.6s4.3.8 5.8 2.6" />
          <path d="M7.4 9.1c1.2-.9 2.7-1.4 4.6-1.4s3.4.5 4.6 1.4" />
        </Stroke>
      );
    case "dont_know_what":
      return (
        <Stroke>
          <circle cx="12" cy="12" r="6.3" />
          <path d="M12 15.7v.1" />
          <path d="M10.3 10.2a1.9 1.9 0 1 1 3.4 1.2c-.6.7-1.2 1-1.6 1.8" />
        </Stroke>
      );
    case "ingredients_waste":
    case "deeper_guided":
    case "adventurous":
      return (
        <Stroke>
          <path d="M7.2 14.7c1.6-4.2 4.5-6.5 8.6-6.9" />
          <path d="M15.8 7.8V11h-3.1" />
          <path d="M16.8 14.1a4.9 4.9 0 0 1-4.8 3.7 4.9 4.9 0 0 1-4.7-3.2" />
        </Stroke>
      );
    case "takes_too_long":
    case "one_two":
    case "three_four":
    case "almost_daily":
      return (
        <Stroke>
          <rect x="6.6" y="7.2" width="10.8" height="9.8" rx="2" />
          <path d="M9.2 5.8v2.1" />
          <path d="M14.8 5.8v2.1" />
          <path d="M9.2 11.1h5.6" />
        </Stroke>
      );
    case "too_complicated":
      return (
        <Stroke>
          <circle cx="8" cy="8.6" r="1.4" />
          <circle cx="16" cy="8.6" r="1.4" />
          <circle cx="8" cy="15.4" r="1.4" />
          <circle cx="16" cy="15.4" r="1.4" />
          <path d="M9.3 8.6h5.4" />
          <path d="M8 10v4" />
          <path d="M16 10v4" />
          <path d="M9.3 15.4h5.4" />
        </Stroke>
      );
    case "rarely":
      return (
        <Stroke>
          <circle cx="12" cy="12" r="6" />
          <path d="M8 16l8-8" />
        </Stroke>
      );
    case "heard_not_sure":
    case "tried_once":
      return (
        <Stroke>
          <path d="M7.2 8.4c1.6-.9 3.2-1.3 4.8-1.3 2.3 0 3.8.8 4.8 2.4" />
          <path d="M16.8 15.6c-1.6.9-3.2 1.3-4.8 1.3-2.3 0-3.8-.8-4.8-2.4" />
          <path d="M15.9 6.8l1.1 2.4-2.6.4" />
          <path d="M8.1 17.2L7 14.8l2.6-.4" />
        </Stroke>
      );
    case "no_idea":
    case "never":
      return (
        <Stroke>
          <path d="M8 8.5l8 8.9" />
          <path d="M16 8.5L8 17.4" />
          <circle cx="12" cy="12" r="6.4" />
        </Stroke>
      );
    case "all_the_time":
    case "sometimes":
      return (
        <Stroke>
          <circle cx="12" cy="12" r="5.9" />
          <path d="M12 9v3.2l2.2 2" />
        </Stroke>
      );
    case "story_first":
    case "one_pot":
      return (
        <Stroke>
          <path d="M8 8.2h8" />
          <path d="M7 12h10" />
          <path d="M8.8 15.8h6.4" />
        </Stroke>
      );
    case "healthy":
      return (
        <Stroke>
          <path d="M12 5.6c2.2 1.9 3.8 4.1 3.8 6.2A3.8 3.8 0 1 1 8.2 11.8c0-2.1 1.6-4.3 3.8-6.2Z" />
          <path d="M10 13.8c1.1.6 2.9.6 4 0" />
        </Stroke>
      );
    case "save_takeout":
      return (
        <Stroke>
          <path d="M12 17.2s-4.2-2.5-4.2-6.2a2.5 2.5 0 0 1 4.2-1.9 2.5 2.5 0 0 1 4.2 1.9c0 3.7-4.2 6.2-4.2 6.2z" />
        </Stroke>
      );
    case "closer_to_sikhi":
    case "enjoy_kitchen":
      return (
        <Stroke>
          <path d="M8 7.8h5a2 2 0 0 1 1.4.6l.6.6H17v8.2h-3.4a2 2 0 0 0-1.4-.6H8V7.8Z" />
          <path d="M12 8.4v8.2" />
          <path d="M15.9 6.2l.4 1 .9.4-.9.4-.4 1-.4-1-.9-.4.9-.4.4-1Z" />
        </Stroke>
      );
    case "lose_weight":
      return (
        <Stroke>
          <path d="M6.2 12c0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8" />
          <path d="M8.5 14.8c1.2 1.2 2.2 1.8 3.5 1.8s2.3-.6 3.5-1.8" />
          <path d="M12 7.6v8.8" />
        </Stroke>
      );
    default:
      return (
        <Stroke>
          <circle cx="12" cy="12" r="6.1" />
          <path d="M12 9.1v5.8" />
          <path d="M9.1 12H15" />
        </Stroke>
      );
  }
};

export const OptionGlyph = ({ optionId }: OptionGlyphProps) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    {renderGlyph(optionId)}
  </svg>
);
